import styled from 'styled-components';
import background from '../../assets/images/background.png'

export const StyledRow = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    /* padding: 2em 0 4em 0; */
`

export const CalendlyWrapper = styled.div`
    display: inherit;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-image: ${background};
    background-color: #1a1a1a;
    width: 70%;
    height: ${props => props.height};
    min-width:${props => props.width};
`


// WEBPACK FOOTER //
// ./src/components/CalendlyBooking/CalendlyBooking.styles.ts